import m from "../../es2015/lang/bs_BA";
window.am4lang_bs_BA = m;


//////////////////
// WEBPACK FOOTER
// ./lang/bs_BA.js
// module id = null
// module chunks = 